// extracted by mini-css-extract-plugin
module.exports = {"margin-card":"CertificateForm_margin-card__5IXHd","submit-button":"CertificateForm_submit-button___7Lp4","terms-text":"CertificateForm_terms-text__pBvTD"};